let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("eLY7w")).then(() => parcelRequire('hLcUD'));